
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/event-handlers",
      function () {
        return require("private-next-pages/examples/event-handlers.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/event-handlers"])
      });
    }
  